import { Col, Collapse } from 'antd';
import React from 'react';
import { accordionContentType } from '../../hooks/useAccordions';
import { createMarkup } from '../../util/renderHelpers';

type accordionType = {
  children?: never;
  accordionState: accordionContentType;
};

const Accordion: React.FC<accordionType> = ({ accordionState }) => {
  const displayAccordion = accordionState.map(
    (accordion, index) =>
      accordion.content && (
        <Collapse.Panel
          className="accordion"
          key={index}
          header={accordion.title}
          forceRender={true}
        >
          <div dangerouslySetInnerHTML={createMarkup(accordion.content)} />
        </Collapse.Panel>
      )
  );

  const buttonAccordion = (accordion: any) => (
    <div>
      <div className={`accordion-icon${accordion.isActive ? ' active' : ''}`} />
    </div>
  );

  return (
    <Col lg={{ span: 20 }}>
      <Collapse
        bordered={false}
        className="accordions"
        defaultActiveKey={accordionState[0].collapse}
        expandIconPosition="right"
        expandIcon={buttonAccordion}
      >
        {displayAccordion}
      </Collapse>
    </Col>
  );
};

export default Accordion;
